import { LitElement, html, svg } from 'lit';

export class IconBoatLength32 extends LitElement {
  render() { return html`<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none" viewBox="0 0 32 32"><title>Båt med piler i begge retninger</title><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="m26 10.667-2-2H2.345a.542.542 0 0 0-.492.768A12.997 12.997 0 0 0 13.66 17H29.5v-6.333H26ZM2 25.333h28M9.333 8.667l4.667-6M4.619 22.667 2 25.333 4.619 28M27.38 22.667 30 25.333 27.38 28"></path></svg>`; }
}
if (!customElements.get('f-icon-boat-length32', IconBoatLength32)) {
  customElements.define('f-icon-boat-length32', IconBoatLength32);
}